import React from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

/** Statuts Stripe qui signifient « le client n'a pas payé ». */
export const FAILED_PAYMENT_STATUSES = ['past_due', 'unpaid'];

export const SUBSCRIPTION_STATUS_COLORS: Record<string, string> = {
	active: '#4caf50',
	trialing: '#2196f3',
	past_due: '#ff9800',
	canceled: '#f44336',
	incomplete: '#9e9e9e',
	unpaid: '#f44336',
};

export const SubscriptionStatus: React.FC<{ status?: string }> = ({ status }) => (
	<span
		style={{
			color: SUBSCRIPTION_STATUS_COLORS[status || ''] || '#000',
			fontWeight: 600,
		}}
	>
		{status || '—'}
	</span>
);

// Lien vers Stripe Dashboard. Stripe redirige vers le bon mode (test/live)
// selon la session loggée — on pointe sur /subscriptions/<id> par défaut.
export const stripeUrl = (subId: string): string => {
	const w: any = typeof window !== 'undefined' ? window : {};
	const live = w.STRIPE_LIVE === true || w.STRIPE_LIVE === 'true';
	const base = live ? 'https://dashboard.stripe.com' : 'https://dashboard.stripe.com/test';
	return `${base}/subscriptions/${subId}`;
};

/**
 * Lien vers la subscription dans Stripe.
 *
 * Le libellé est paramétrable pour ne pas imposer sa langue aux écrans qui
 * utilisaient déjà ce lien : la liste des subscriptions reste en anglais.
 */
export const StripeLink: React.FC<{ subId?: string; label?: string }> = ({
	subId,
	label = 'Open',
}) => {
	if (!subId) return null;
	return (
		<a
			href={stripeUrl(subId)}
			target="_blank"
			rel="noopener noreferrer"
			onClick={(e) => e.stopPropagation()}
			style={{
				display: 'inline-flex',
				alignItems: 'center',
				color: '#635bff',
				textDecoration: 'none',
				fontWeight: 500,
			}}
		>
			{label} <OpenInNewIcon style={{ fontSize: 14, marginLeft: 4 }} />
		</a>
	);
};
